export default __webpack_public_path__ + "static/media/shield-icon.daefe14b.svg";